<template>
    <div>
        <div
            v-for="(component, rootindex) of tree"
            :key="rootindex"
            class="component-tree-button"
        >
            <div
                title="Редактировать..."
                class="component-name"
                @click="focus($event, component.id)"
                @mouseover.stop="highlightOn(component.id)"
                @mouseout.stop="highlightOff(component.id)"
            >
                <span v-text="component.description || component.type" />
            </div>
            <div>
                <div
                    v-for="(containertree, index) of component.tree"
                    :key="index"
                >
                    <treeview
                        v-if="containertree.length"
                        ref="child"
                        :collapse="true"
                        :tree="containertree"
                        style="padding: 2px 5px; margin-bottom: 5px; margin-left: 20px; border: 1px solid gray;"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TreeView',
    props: {
        tree: {
            type: Array,
            default: function() { return [] } 
        },
        collapse: {
            type: Boolean,
            default: false,
        },
    },
    data: function(){
        return {
            hovered: null,
            collapsed: this.collapse || false,
        }
    },
    computed: {
         existingTreeElements: function(){
            return this.tree.filter(x => x.length > 0);
        }
    },
    methods: {
        focus: function(event, id){
            if (this.$root.componentRefs[id]) {
                this.$root.componentRefs[id].$el.scrollIntoView({block: "center", behavior: "smooth"});
                this.$root.componentRefs[id].selectTriggerFocus();
            }
        },
        highlightOn: function(id){
            if (!this.$root.editorActive) {
                this.hovered = id;
                if (this.$root.componentRefs[id]) {
                    this.$root.componentRefs[id].$el.scrollIntoView({block: "center", behavior: "smooth"});
                    this.$root.componentRefs[id].highlightOn(null);
                }
            }
        },
        highlightOff: function(id){
            this.hovered = null;
            this.$root.componentRefs[id].highlightOff(null);
        },
        removeComponent: function(id) {
            this.$root.componentRefs[id].$emit('remove', id, null);
        }
    }
}
</script>
